<template>
 <div class="mt-3">
   <div :class="styletable.row">
     <div :class="styletable.col1">Origin Country</div>
     <div :class="styletable.col3">:</div>
     <div :class="styletable.col2">{{custDetail.countryf}}</div>
   </div>

   <div :class="styletable.row">
     <div :class="styletable.col1">Origin City</div>
     <div :class="styletable.col3">:</div>
     <div :class="styletable.col2">{{custDetail.cityf}}</div>
   </div>

   <div :class="styletable.row" v-if="!hideByShipmentService(custDetail.optiontp, 'PICKUP')
                                      || custDetail.shipment_type === 'BARGE'
                                      || custDetail.shipment_type === 'LCT'">
     <div :class="styletable.col1" v-if="custDetail.shipment_type === 'BARGE'
                                      || custDetail.shipment_type === 'LCT'">
                                      Origin Address or Jetty Coordinate Point</div>
     <div :class="styletable.col1" v-else>Pick Up Address</div>
     <div :class="styletable.col3">:</div>
     <div :class="styletable.col2">
       {{custDetail.pickup_address || custDetail.delivery_address_ori}}
     </div>
   </div>

   <div :class="styletable.row">
     <div :class="styletable.col1">Destination Country</div>
     <div :class="styletable.col3">:</div>
     <div :class="styletable.col2">{{custDetail.countryt}}</div>
   </div>

   <div :class="styletable.row">
     <div :class="styletable.col1">Destination City</div>
     <div :class="styletable.col3">:</div>
     <div :class="styletable.col2">{{custDetail.cityt}}</div>
   </div>

   <div :class="styletable.row" v-if="!hideByShipmentService(custDetail.optiontp, 'DELIVERY')
                                      || custDetail.shipment_type === 'BARGE'
                                      || custDetail.shipment_type === 'LCT'">
     <div :class="styletable.col1" v-if="custDetail.shipment_type === 'BARGE'
                                      || custDetail.shipment_type === 'LCT'">
                                      Destination Address or Jetty Coordinate Point</div>
     <div :class="styletable.col1" v-else>Delivery Address</div>
     <div :class="styletable.col3">:</div>
     <div :class="styletable.col2">
       {{ custDetail.delivery_address || custDetail.delivery_address_desti}}
     </div>
   </div>

   <div :class="styletable.row" v-if="typeRequest === 'RFQ'">
     <div :class="styletable.col1">Shipper Notes</div>
     <div :class="styletable.col3">:</div>
     <div :class="styletable.col2">{{custDetail.shipper_notes || '-'}}</div>
   </div>
 </div>
</template>
<script>
export default {
  name: 'AddressDetails',
  props: {
    typeRequest: String,
    custDetail: Object
  },
  data () {
    return {
      styletable: {
        row: 'row m-0 mb-1',
        col1: 'col-md-4 pl-0',
        col2: 'col-md pl-1 textcolor textbold',
        col3: 'col-md-0'
      }
    }
  },

  mounted () {
  },

  methods: {
    hideByShipmentService (service, type) {
      let status = true // ptp & dtd
      if (service === 'dtp') {
        switch (type) {
          case 'PICKUP': status = false
            break
        }
      } else if (service === 'ptd') {
        switch (type) {
          case 'DELIVERY': status = false
            break
        }
      } else if (service === 'dtd') {
        switch (type) {
          case 'PICKUP': status = false
            break
          case 'DELIVERY': status = false
            break
        }
      }
      return status
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/detail/tabs-detail/AddressDetails.vue